export default __webpack_public_path__ + "2ace62d8ac9e39935e766468f9a39733.png";